module.exports = __webpack_public_path__ + "img/GI.b614c081.png";